import Statistics from '../views/Statistics'
export default [
  {
    path: '/admin/stats',
    name: 'stats',
    component: Statistics
  }
]
